import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import Feature from 'ol/Feature';

import { Icon, Stroke, Style } from 'ol/style';

import { BingMaps, XYZ } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import * as olProj from 'ol/proj';

import { LineString, MultiPoint, Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import axios1 from 'axios';

import { Text, Fill } from 'ol/style';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { Router } from '@angular/router';

declare let $: any;


@Component({

  selector: 'app-trip-cartable',

  templateUrl: './trip-cartable.component.html',

  styleUrls: ['./trip-cartable.component.css']

})

export class TripCartableComponent implements OnInit {

  isLoading: boolean = false;

  bEditMode: boolean = false;

  isManageTrip: boolean = false;

  trips: any;

  currentRecord: any;

  tripReasons: any;

  source: any;

  vector: any;

  layers: any = [];

  map: any;

  vectorLayer: any;

  vehicleTypes: any;

  mapHeader: any;

  mapMode: any;

  destination: any;

  origin: any;

  @Input() tripObj!: {};

  @Output() tripModal_Close = new EventEmitter<boolean | object>();

  path: FormGroup = this.formBuilder.group({

    origin: new FormControl('',),

    destination: new FormControl(''),

    olatIn: new FormControl('',),

    dlatIn: new FormControl('',),

    olongIn: new FormControl('',),

    dlongIn: new FormControl('',),

    addressBar: new FormControl(''),

    duration: new FormControl(''),

    distance: new FormControl(''),

    temp_mapMode: new FormControl(''),

    temp_dlatIn: new FormControl(''),

    temp_dlongIn: new FormControl(''),

    temp_olatIn: new FormControl(''),

    temp_olongIn: new FormControl(''),

  })

  tripInfo: FormGroup = this.formBuilder.group({

    tripRes: new FormControl(''),

    vehType: new FormControl(''),

    tripTripDate: new FormControl(''),

    tripReqDate: new Date()
  })

  mdlTripEdit: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iOffitialTrip: new FormControl(''),

    iOfficialTrip: new FormControl(''),

    fsLat: new FormControl(''),

    fsLon: new FormControl(''),

    strSourceAddress: new FormControl(''),

    fDLat: new FormControl(''),

    fDLon: new FormControl(''),

    strDestinationAddress: new FormControl(''),

    bMissionary: new FormControl(''),

    bExclusive: new FormControl(''),

    bHaveReturn: new FormControl(''),

    strPassengersName: new FormControl(''),

    strPassengersMobile: new FormControl(''),

    strTripDate: new FormControl(''),

    strTripTime: new FormControl(''),

    tiTripImportance: new FormControl(''),

    tiTripReason: new FormControl(''),

    tiMobileType: new FormControl(''),

    strComment: new FormControl(''),

    MobileType: new FormControl(''),

    bCheckByQRCode: new FormControl(false),

  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private notify: NotificationService,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _router: Router

  ) { }

  ngOnInit(): void {

    // ویرایش سفر توسط صفحه مدیریت سفرها

    if (this.tripObj) {

      this.isManageTrip = true;

      this.showDetailsModal(this.tripObj, true);

    }

    this.getTrips();

    this.getTripReasons();

    this.getVehicleTypes();
  }

  async getVehicleTypes() {

    let res = JSON.parse((await axios.post(`MobileType_List`, {})).data.toString());

    this.vehicleTypes = res;

  }

  UpdateTrip() {

    let TripTime = document.getElementById('Ttime') as any;

    this.mdlTripEdit.get('strTripTime')?.setValue(TripTime.value)

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            const resp = await axios.post(`OffitialTrip_Edit`, this._otherService.stringNumberToNumber(this.mdlTripEdit.value));

            this._otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.iResult == 0) return this.notify.showError(res.strError);

            if (res.ISSessionExpired == true) {

              this.notify.showError('لطفا وارد سیستم شوید');

              this._otherService.removeLocalStorage();

              this._router.navigate(['login']);

              return;

            }

            else {

              this.notify.showSuccess("با موفقیت ویرایش شد");

              $('#DetailModal').modal('hide');

              const tripEdited = this.trips.filter((el: any) => {

                return el.iOfficialTrip == res[0].iOfficialTrip

              });

              const index = this.trips.indexOf(tripEdited[0]);

              if (index != -1) this.trips[index] = res[0];

              this.closeEditTrip(res[0]);

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  async getTripReasons() {

    let res = JSON.parse((await axios.post(`TripReason_List`, {})).data.toString());

    this.tripReasons = res;

  }

  editTripModal(item: any) {

    this.currentRecord = null;

    this.currentRecord = item;

    Object.keys(item).forEach(key => {

      this.mdlTripEdit.get(key)?.setValue(item[key])

    })

    this.tripInfo.controls['tripRes'].setValue(item.tiTripReason);

    this.tripInfo.controls['vehType'].setValue(item.tiMobileType);

    this.tripInfo.controls['tripReqDate'].setValue(item.strRequestDate);

    this.tripInfo.controls['tripTripDate'].setValue(item.strTripDate);

    let ReqTime = document.getElementById('Etime') as any;

    let TripTime = document.getElementById('Ttime') as any;

    ReqTime.value = item.strRequestTime;

    TripTime.value = item.strTripTime;

    $('#EditModal').modal('show');

  }

  showDetailsModal(item: any, isEdit?: boolean) {

    if (isEdit) {

      this.currentRecord = null;

      this.origin = null;

      this.destination = null;

      this.currentRecord = item;

      this.bEditMode = true;

      Object.keys(item).forEach(key => {

        this.mdlTripEdit.get(key)?.setValue(item[key])

      })

      this.tripInfo.controls['tripRes'].setValue(item.tiTripReason);

      this.tripInfo.controls['vehType'].setValue(item.tiMobileType);

      this.tripInfo.controls['tripReqDate'].setValue(item.strRequestDate);

      this.tripInfo.controls['tripTripDate'].setValue(item.strTripDate);

      $('#DetailModal').modal('show');

      setTimeout(() => {

        let ReqTime = document.getElementById('Etime') as any;

        let TripTime = document.getElementById('Ttime') as any;

        if (ReqTime) ReqTime.value = item.strRequestTime;

        if (TripTime) TripTime.value = item.strTripTime;

      }, 100);

    }

    else {

      this.bEditMode = false;

      this.currentRecord = item;

      $('#DetailModal').modal('show');

    }

  }

  newMapShowTripSourceAndDest(item: any) {
    $('#maplat').modal('show');
    if (this.map)
      this.map.setTarget(null);
    setTimeout(() => {
      this.map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM()
          })
        ],
        view: new View({
          center: olProj.fromLonLat([item.fsLon, item.fsLat]),
          zoom: 15
        })
      });

      const startCoords = olProj.fromLonLat([item.fsLon, item.fsLat]);
      const destinationCoords = olProj.fromLonLat([item.fDLon, item.fDLat]);

      const startFeature = new Feature({
        geometry: new Point(startCoords)
      });

      const destFeature = new Feature({
        geometry: new Point(destinationCoords)
      });

      const startIcon = new Icon({
        src: '../../assets/Img/marker4.png',
        size: [48, 48],
      });


      const destIcon = new Icon({
        src: '../../assets/Img/marker5.png',
        size: [48, 48]
      });


      startFeature.setStyle(new Style({
        image: startIcon, text: new Text({
          text: 'مبدأ', // Replace with desired text
          offsetY: -30, // Adjust the vertical position
          font: '16px Vazir', // Set the font style
          fill: new Fill({ color: 'Green' }), // Set the text color
          stroke: new Stroke({ color: 'blue', width: 1 })

        })
      }));
      destFeature.setStyle(new Style({
        image: destIcon, text: new Text({
          text: 'مقصد', // Replace with desired text
          offsetY: -30, // Adjust the vertical position
          font: '16px Vazir', // Set the font style
          fill: new Fill({ color: 'Red' }), // Set the text color
          stroke: new Stroke({ color: 'blue', width: 1 })
        })
      }));


      const apiKey = '5b3ce3597851110001cf6248f929f5c0617b429ba92f0e10df39ced9';
      const apiUrl = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${item.fsLon},${item.fsLat}&end=${item.fDLon},${item.fDLat}`;

      axios1.get(apiUrl)
        .then(response => {
          const routeCoordinates = response.data.features[0].geometry.coordinates;
          const transformedRouteCoordinates = routeCoordinates.map((coord: any) => olProj.fromLonLat([coord[0], coord[1]]));

          const routeData = response.data.features[0];
          ;

          this.path.controls['duration'].setValue(this.formatDuration(routeData.properties.summary.duration));
          this.path.controls['distance'].setValue((routeData.properties.summary.distance / 1000).toFixed(2));
          const routeGeometry = new LineString(transformedRouteCoordinates);

          const routeFeature = new Feature({
            geometry: routeGeometry
          });

          const routeStyle = new Style({
            stroke: new Stroke({
              color: 'blue',
              width: 3,
              lineDash: [6, 6]
            }),
          });

          routeFeature.setStyle(routeStyle);

          const vectorSource = new VectorSource({
            features: [startFeature, destFeature, routeFeature]
          });


          this.vectorLayer = new VectorLayer({
            source: vectorSource
          });

          this.map.addLayer(this.vectorLayer);

          const iconCoordinates = [startCoords, destinationCoords];
          const boundingBox = new LineString(iconCoordinates).getExtent();
          this.map.getView().fit(boundingBox, { padding: [50, 50, 50, 50] });
        })
        .catch(error => {
          console.error('Error fetching route:', error);
        });

    }, 500);
  }

  formatDuration(duration: any) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    return `${hours}:${minutes}`;
  }

  //confirm trip

  async setTripConfirmation(modalName: any) {
    if (confirm(`آیا از تأیید سفر با کد ${this.currentRecord.iOfficialTrip} اطمینان دارید؟`)) {
      let model = {
        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        iOffitialTrip: this.currentRecord.iOfficialTrip,
      }
      let res = JSON.parse((await axios.post(`OffitialTrip_Confirm`, model)).data.toString());

      if (res.iResult == 0)
        return this.notify.showError(res.strError)

      this.notify.showSuccess('سفر مورد نظر با موقت تأیید شد');
      $(`#${modalName}`).modal('hide');
      this.getTrips();
    }
  }

  //reject trip

  async setTripRejection(modalName: any, item?: any) {

    if (item) {

      if (confirm(`آیا از لغو سفر با کد ${item.iOfficialTrip} اطمینان دارید؟`)) {

        let model = {

          strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          iOffitialTrip: item.iOfficialTrip,

        }

        let res = JSON.parse((await axios.post(`OffitialTrip_Cancel`, model)).data.toString());

        if (res.strError) return this.notify.showError(res.strError)

        this.notify.showSuccess('سفر مورد نظر با موقت لغو شد');

        this.getTrips();

      }

    }

    else {

      if (confirm(`آیا از لغو سفر با کد ${this.currentRecord.iOfficialTrip} اطمینان دارید؟`)) {

        let model = {

          strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          iOffitialTrip: this.currentRecord.iOfficialTrip,

        }

        let res = JSON.parse((await axios.post(`OffitialTrip_Cancel`, model)).data.toString());

        if (res.strError) return this.notify.showError(res.strError)

        this.notify.showSuccess('سفر مورد نظر با موقت لغو شد');

        $(`#${modalName}`).modal('hide');

        this.getTrips();

      }

    }

  }

  //show confirm trip modal

  confirmTripModal(item: any) {
    $('#confirmModal').modal('show');
    this.currentRecord = item;
  }

  async getTrips() {

    let model = this._otherService.stringNumberToNumber({

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      tiAppUsage: 1,

      tiTripStatus: 0

    })

    let res = JSON.parse((await axios.post(`OffitialTrip_List`, model)).data.toString());

    this.trips = res;

    this.isLoading = false;

  }

  newOpenMap = (mode: number) => {

    this.path.patchValue({

      olatIn: this.currentRecord.fsLat,

      olongIn: this.currentRecord.fsLon,

      dlatIn: this.currentRecord.fDLat,

      dlongIn: this.currentRecord.fDLon,

      addressBar: mode == 0 ? this.currentRecord.strSourceAddress : this.currentRecord.strDestinationAddress,

    })

    this.mapMode = mode;

    mode == 0 ? this.mapHeader = 'ویرایش مبدأ' : this.mapHeader = 'ویرایش مقصد';

    $('#DetailModal').modal('hide'); // مدال اطلاعات سفر

    $('#mapModal').modal('show'); // مدال نقشه

    setTimeout(() => {

      if (this.map) {

        this.map.setTarget(null);

      }

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({
        image: new Icon(({
          anchor: [0, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          size: [48, 48],
          opacity: 1,
          src: '../../assets/Img/marker4.png'
        }))
      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }


      if (this.path.get('olatIn')?.value != '' && this.path.get('olongIn')?.value != '' && this.mapMode == 0) {

        this.map = new Map({

          layers: this.layers,

          target: 'mapEdit',

          controls: [],

          view: new View({

            center: olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value]),

            zoom: 18,

          }),

        });

        var iconGeometry = new Point(olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value]))

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.addLayer(dinamicPinLayer);

      }

      else if (this.path.get('dlatIn')?.value != '' && this.path.get('dlongIn')?.value != '' && this.mapMode == 1) {

        this.map = new Map({

          layers: this.layers,

          target: 'mapEdit',

          controls: [],

          view: new View({

            center: olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]),

            zoom: 18,

          }),

        });

        var iconGeometry = new Point(olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]))

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.addLayer(dinamicPinLayer);

      }

      else {

        this.map = new Map({
          layers: this.layers,
          target: 'mapEdit',
          controls: [],
          view: new View({
            center: olProj.fromLonLat([51.3833554, 35.6770113]),
            zoom: 13,
          }),
        });
      }

      this.map.on('click', (e: any) => {

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        if (this.mapMode == 0) { // مبداء

          this.path.controls['temp_mapMode'].setValue(0)

          this.path.controls['temp_olatIn'].setValue(coords[1])

          this.path.controls['temp_olongIn'].setValue(coords[0])

          this.setReverseGeocode(this.path.controls['temp_olatIn'].value, this.path.controls['temp_olongIn'].value);

        }

        else if (this.mapMode == 1) { // مقصد

          this.path.controls['temp_mapMode'].setValue(1)

          this.path.controls['temp_dlatIn'].setValue(coords[1])

          this.path.controls['temp_dlongIn'].setValue(coords[0])

          this.setReverseGeocode(this.path.controls['temp_dlatIn'].value, this.path.controls['temp_dlongIn'].value);


        }

        var iconGeometry = new Point(e.coordinate);

        var iconFeature = new Feature({

          geometry: iconGeometry,

          properties: {

            name: 'mapMarker'

          }

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          if (layer.getKeys().length < 11) this.map.removeLayer(layer);

        });

        this.map.addLayer(dinamicPinLayer);

      })

      this.map.on('pointermove', (e: any) => {
        var pixel = this.map.getEventPixel(e.originalEvent);
        var hit = this.map.hasFeatureAtPixel(pixel);
        this.map.getViewport().style.cursor = 'pointer';
      });

    }, 500);


  }

  async setReverseGeocode(lat: any, long: any) {

    let res = (await axios.post(`ReverseGeocoding_FleetYar`, {

      'fLat': lat,

      'fLon': long

    }));

    this.path.controls['addressBar'].setValue(res.data.strAddress);

  }

  async getLocationGeocoding(source: any, int: any, value: any) {

    var model = this._otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strAddress: value

    })

    let res = JSON.parse((await axios.post(`Geocoding_FleetYar`, model)).data.toString());

    if (res.iResult == -1) return this.notify.showError(res.strComment);

    if (source == 1 && int == 0) this.path.controls['origin'].setValue(model.strAddress); // مبدا

    if (source == 1 && int == 1) this.path.controls['destination'].setValue(model.strAddress); // مقصد

    if (int == 0) {

      this.origin = res;

      this.path.controls['olatIn'].setValue(this.origin.fLat)

      this.currentRecord.fsLat = this.origin.fLat;

      this.path.controls['olongIn'].setValue(this.origin.fLon)

      this.currentRecord.fsLon = this.origin.fLon;

      this.path.controls['temp_olatIn'].setValue(this.origin.fLat)

      this.path.controls['temp_olongIn'].setValue(this.origin.fLon)

      this.path.controls['addressBar'].setValue(value);

      this.currentRecord.strSourceAddress = value;


    }

    else {

      this.destination = res

      this.path.controls['dlatIn'].setValue(this.destination.fLat);

      this.currentRecord.fDLat = this.destination.fLat;

      this.path.controls['dlongIn'].setValue(this.destination.fLon);

      this.currentRecord.fDLon = this.destination.fLon;

      this.path.controls['temp_dlatIn'].setValue(this.destination.fLat)

      this.path.controls['temp_dlongIn'].setValue(this.destination.fLon)

      this.path.controls['addressBar'].setValue(value);

      this.currentRecord.strDestinationAddress = value;


    }

    if (source == 1) {

      this.map.getLayers().forEach((layer: VectorSource) => {

        if (layer.getKeys().length < 11)

          this.map.removeLayer(layer);

      });

      var iconStyle = new Style({
        image: new Icon(({
          anchor: [0, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          size: [48, 48],
          opacity: 1,
          src: '../../assets/Img/marker4.png'
        }))
      });

      var iconGeometry;

      this.mapMode == 0 ?

        iconGeometry = new Point(olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value])) :

        iconGeometry = new Point(olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]))

      var iconFeature = new Feature({

        geometry: iconGeometry,

      });

      iconFeature.setStyle(iconStyle);

      var vectorSource = new Vector({

        features: [iconFeature]

      });

      var dinamicPinLayer = new VectorLayer({

        source: vectorSource

      });

      this.map.addLayer(dinamicPinLayer);

      this.mapMode == 0 ?

        this.map.getView().setCenter(olProj.transform([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value], 'EPSG:4326', 'EPSG:3857')) :

        this.map.getView().setCenter(olProj.transform([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value], 'EPSG:4326', 'EPSG:3857'))

      this.map.getView().getZoom() == 13 ? this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 5,

        duration: 250

      }) : this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 0,

        duration: 250

      })

    }

  }

  confirmMap() {

    if (this.mapMode == 0) {

      this.path.controls['olatIn'].setValue(this.path.get('temp_olatIn')?.value);

      this.currentRecord.fsLat = this.path.get('temp_olatIn')?.value;

      this.path.controls['olongIn'].setValue(this.path.get('temp_olongIn')?.value);

      this.currentRecord.fsLon = this.path.get('temp_olongIn')?.value;

      this.currentRecord.strSourceAddress = this.path.get('addressBar')?.value; // مبدا

      this.mdlTripEdit.patchValue({

        fsLat: this.currentRecord.fsLat,

        fsLon: this.currentRecord.fsLon,

        strSourceAddress: this.currentRecord.strSourceAddress,

      })

    }

    else {

      this.path.controls['dlatIn'].setValue(this.path.get('temp_dlatIn')?.value);

      this.currentRecord.fDLat = this.path.get('temp_dlatIn')?.value;

      this.path.controls['dlongIn'].setValue(this.path.get('temp_dlongIn')?.value);

      this.currentRecord.fDLon = this.path.get('temp_dlongIn')?.value;

      this.currentRecord.strDestinationAddress = this.path.get('addressBar')?.value; // مقصد

      this.mdlTripEdit.patchValue({

        fDLat: this.currentRecord.fDLat,

        fDLon: this.currentRecord.fDLon,

        strDestinationAddress: this.currentRecord.strDestinationAddress,

      })

    }

    this.path.controls['addressBar'].setValue('');

    this.showDetailsModal(this.currentRecord, true);

  }

  closeEditTrip(tripObj?: any) {

    this.tripModal_Close.emit(tripObj ? tripObj : true);

  }

}


